/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDashboardRequest } from '../../models/create-dashboard-request';
import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardsPost$Plain$Params {
      body?: CreateDashboardRequest
}

export function dashboardsPost$Plain(http: HttpClient, rootUrl: string, params?: DashboardsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsPost$Plain.PATH = '/dashboards';
